const GA_ID = "G-NTFS7EWSNS";

function gtag(...args) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag(...args);
}

function track(event, params = {}) {
  gtag("event", event, { send_to: GA_ID, ...params });
}

// ─── Store / Download ────────────────────────────────────────
// Самый важный ивент — показывает намерение скачать
export function trackStoreClick(store, location) {
  track("store_cta_click", {
    event_category:  "conversion",
    event_label:     `${store} – ${location}`,
    store_platform:  store,      // "apple" | "google"
    click_location:  location,   // "hero" | "download_cta" | "footer"
  });
}

// ─── Section visibility ──────────────────────────────────────
// Понимаем до какого блока долистывают
export function trackSectionView(section) {
  track("section_view", {
    event_category: "engagement",
    section_name:   section,
  });
}

// ─── FAQ ────────────────────────────────────────────────────
export function trackFaqOpen(index, question) {
  track("faq_expand", {
    event_category:   "engagement",
    question_index:   index,
    question_preview: question.substring(0, 80),
  });
}

export function trackFaqClose(index) {
  track("faq_collapse", {
    event_category: "engagement",
    question_index: index,
  });
}

// ─── Navigation ──────────────────────────────────────────────
export function trackNavClick(href, label) {
  track("nav_click", {
    event_category: "navigation",
    link_href:      href,
    link_text:      label,
  });
}

export function trackMobileMenuOpen() {
  track("mobile_menu_open", { event_category: "navigation" });
}

// ─── Hero ───────────────────────────────────────────────────
export function trackHeroScrollCta() {
  track("hero_scroll_cta_click", {
    event_category: "engagement",
    event_label:    "Как это работает",
  });
}

// ─── Contacts / Social ───────────────────────────────────────
export function trackContactClick(type, location) {
  track("contact_click", {
    event_category:  "engagement",
    contact_type:    type,     // "email" | "telegram" | "instagram" | "app_store" | "google_play"
    click_location:  location, // "faq" | "footer"
  });
}

// ─── Scroll depth ────────────────────────────────────────────
// Насколько глубоко читают страницу
export function trackScrollDepth(depthPercent) {
  track("scroll_depth", {
    event_category:   "engagement",
    depth_percent:    depthPercent, // 25 | 50 | 75 | 90 | 100
    non_interaction:  true,
  });
}

// ─── Time on page ────────────────────────────────────────────
// Сколько времени провели на странице перед уходом
export function trackTimeOnPage(seconds) {
  track("time_on_page", {
    event_category:  "engagement",
    seconds_spent:   seconds,
    time_bucket:     seconds < 15  ? "< 15s"
                   : seconds < 30  ? "15–30s"
                   : seconds < 60  ? "30–60s"
                   : seconds < 180 ? "1–3 min"
                   : seconds < 300 ? "3–5 min"
                   : "> 5 min",
    non_interaction: true,
  });
}
